import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { createStyles, getSize } from '@mantine/styles';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var useStyles = createStyles(function (theme, _params, _ref) {
  var size = _ref.size;
  return {
    item: __spreadProps(__spreadValues({}, theme.fn.fontStyles()), {
      boxSizing: "border-box",
      whiteSpace: "pre",
      textAlign: "left",
      width: "100%",
      padding: "calc(".concat(getSize({
        size,
        sizes: theme.spacing
      }), " / 1.5) ").concat(getSize({
        size,
        sizes: theme.spacing
      })),
      cursor: "pointer",
      fontSize: getSize({
        size,
        sizes: theme.fontSizes
      }),
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      borderRadius: theme.fn.radius(),
      "&[data-hovered]": {
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[1]
      },
      "&[data-selected]": __spreadValues({
        backgroundColor: theme.fn.variant({
          variant: "filled"
        }).background,
        color: theme.fn.variant({
          variant: "filled"
        }).color
      }, theme.fn.hover({
        backgroundColor: theme.fn.variant({
          variant: "filled"
        }).hover
      })),
      "&[data-disabled]": {
        cursor: "default",
        color: theme.colors.dark[2]
      }
    }),
    nothingFound: {
      boxSizing: "border-box",
      color: theme.colors.gray[6],
      paddingTop: "calc(".concat(getSize({
        size,
        sizes: theme.spacing
      }), " / 2)"),
      paddingBottom: "calc(".concat(getSize({
        size,
        sizes: theme.spacing
      }), " / 2)"),
      textAlign: "center"
    },
    separator: {
      boxSizing: "border-box",
      textAlign: "left",
      width: "100%",
      padding: "calc(".concat(getSize({
        size,
        sizes: theme.spacing
      }), " / 1.5) ").concat(getSize({
        size,
        sizes: theme.spacing
      }))
    },
    separatorLabel: {
      color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
    }
  };
});
export default useStyles;